module.exports = function atoa (a, n) { return Array.prototype.slice.call(a, n); }



//////////////////
// WEBPACK FOOTER
// /app/~/atoa/atoa.js
// module id = ../../../../atoa/atoa.js
// module chunks = 16